import React from "react";
import "./Requests.css";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import withSnackbar from "../../util/withSnackbar";
import cognitoAuth from "../../util/Cognito";
import Header from "../CeHeader/Header";
import { LinearProgress } from '@mui/material';
import Button from '@mui/material/Button';
import { SNACKBAR_OPTIONS, TIMEOUT } from '../../constants/CommonConstants';
import { errorHandle } from '../../Common/errorHandle';
import CompletionDialog from "../Common/CompletionDialog";
import moment from "moment";
import { DATETIME_FORMAT } from "../../constants/CommonConstants";

class requests extends React.Component{

    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.state = {
            isCompleteDialog: false,
            showChangePassword: this.props.location.state ? this.props.location.state.isInitialLogin : false,
            requestDetails: [],
            requestHistory: [],
            isProgress: false, 
            tipMessage: 'operate_success'
        }
    };

    // リクエスト一覧取得
    requestList = () => {
        let header = {
            'Authorization': '',
            'Content-Type': 'application/json'
        };
        this.setState({ isProgress: true });
        cognitoAuth.getAuthorizationToken().then((token) => {
            header.Authorization = token;
        }, (error) => {
            this.setState({ isProgress: false });
            throw error;
        }).then(() => {
            const controller = new AbortController();
            const props = this;
            const timer = window.setTimeout(errorHandle(function() {
                controller.abort();
                throw props;
            }), TIMEOUT);
            fetch(process.env.REACT_APP_CE_REQUEST_LIST, {
                method: "GET",
                headers: header,
                signal: controller.signal,
            }).then(res => {
                window.clearTimeout(timer);
                if (res.ok) {
                    return res.json();
                }
            }).then(requestDetails => {
                this.setState({
                    requestDetails: getRequestContents(requestDetails)  
                });
            }).catch(() => {
                this.props.openSnackbar(this.props.intl.formatMessage({ id: "server_error" }));
            }).finally(() => {
                this.setState({ isProgress: false });
            });
        });
    }

    // リクエスト履歴一覧取得
    requestHistoryList = () => {        
        let header = {
            'Authorization': '',
            'Content-Type': 'application/json'
        };
        this.setState({ isProgress: true });
        cognitoAuth.getAuthorizationToken().then((token) => {
            header.Authorization = token;
        }, (error) => {
            this.setState({ isProgress: false });
            throw error;
        }).then(() => {
            const controller = new AbortController();
            const props = this;
            const timer = window.setTimeout(errorHandle(function() {
                controller.abort();
                throw props;
            }), TIMEOUT);
            fetch(process.env.REACT_APP_CE_REQUEST_HISTORY_LIST, {
                method: "GET",
                headers: header,
                signal: controller.signal,
            }).then(res => {
                window.clearTimeout(timer);
                if (res.ok) {
                    return res.json();
                }
            }).then(requestHistory => {
                this.setState({
                    requestHistory: getRequestContents(requestHistory).sort((a, b) => b.processedDate.localeCompare(a.processedDate))
                });
            }).catch(() => {
                this.props.openSnackbar(this.props.intl.formatMessage({ id: "server_error" }));
            }).finally(() => {
                this.setState({ isProgress: false });
            });
        });
    }

    componentDidMount() {
        this.requestList();
        this.requestHistoryList();
    }

    approveRequest(targetRequest, isApproved, message) {
        let header = {
            'Authorization': '',
            'Content-Type': 'application/json'
        };
        this.setState({ isProgress: true });
        cognitoAuth.getAuthorizationToken().then((token) => {
            header.Authorization = token;
        }, (error) => {
            this.setState({ isProgress: false });
            throw error;
        }).then(() => {
            const controller = new AbortController();
            const props = this;
            const timer = window.setTimeout(errorHandle(function() {
                controller.abort();
                throw props;
            }), TIMEOUT);
            // リクエスト承認/拒否
            fetch(process.env.REACT_APP_CE_APPROVE_REQUEST, {
                method: "PUT",
                headers: header,
                signal: controller.signal,
                body: JSON.stringify({
                    ceId : targetRequest.ceId,
                    type : targetRequest.type,
                    userId : targetRequest.userId,
                    isApproved : isApproved,
                }),
            }).then(res => {
                window.clearTimeout(timer);
                if (res.ok) {
                    this.setState({
                        isCompleteDialog: true,
                        tipMessage: isApproved ? 'request_approved':'request_disapproved'
                    })
                }else{
                    return res.json()
                }
            })
            .then(
                (data)=>{
                    // deal with the expired ce account(the ce_table do not have this ce account)
                    if (data && data.status === 400 && data.code === "SpecifiedIdNotFound"){
                        this.setState({ 
                            isCompleteDialog: true,
                            tipMessage: 'request_disapproved'
                        });
                    }
                }
            )
            .catch(error => {
                this.props.openSnackbar(this.props.intl.formatMessage({ id: "server_error" }));
            }).finally(() => {
                this.setState({ isProgress: false });
            });
        });
    }

    goBack() {
        this.props.history.goBack();
    }

    handleClose() {
        this.setState({ isCompleteDialog: false });
        this.requestList();
        this.requestHistoryList();
    }
    
    render() {
        return (
            <div id="ceRequests" className="body">
                {this.state.isProgress ? <LinearProgress /> : ''}
                <Header showSubMenu={true} />
                <div className="content">
                    <div className="title mainTitle">{this.props.intl.formatMessage({ id: "request_to_you" })}</div>
                    <div className="title subTitle">{this.props.intl.formatMessage({ id: "ce_request_subTitle" })}</div>
                    <div className="requestListTable">
                        <div className="header">
                            <div className="header-label">
                                <span>{this.props.intl.formatMessage({ id: "sender" })}</span>
                            </div>
                            <div className="header-label">
                                <span>{this.props.intl.formatMessage({ id: "ce_request_header_contents" })}</span>
                            </div>
                            <div className="header-label">
                                <span>{this.props.intl.formatMessage({ id: "ce_request_header_date" })}</span>
                            </div>
                            <div className="header-label">
                                <span>{this.props.intl.formatMessage({ id: "authorization" })}</span>
                            </div>
                        </div>
                        <div className="requestListTable-content">
                            { this.state.requestDetails !== undefined ? this.state.requestDetails.map((request, index) => (
                                <div key={index} className="data">
                                    <div className="data-value">
                                        <input 
                                            type="email" 
                                            name="email" 
                                            value={request.ceId} 
                                            disabled
                                        />
                                    </div>
                                    <div className="data-value">
                                        <input 
                                            type="text" 
                                            name="contents" 
                                            value={request.contents} 
                                            disabled
                                        />
                                    </div>
                                    <div className="data-value">
                                        <input 
                                            type="text" 
                                            name="createdAt" 
                                            value={request.createdAt} 
                                            disabled
                                        />
                                    </div>
                                    <div className="data-value">
                                        <Button 
                                            fullWidth 
                                            className="button approveButton" 
                                            onClick={() => this.approveRequest(request, true, "request_approved")}
                                        >
                                            {this.props.intl.formatMessage({ id: "approve" })}
                                        </Button>
                                        <Button 
                                            fullWidth 
                                            className="button doNotApproveButton" 
                                            onClick={() => this.approveRequest(request, false, "request_disapproved")} 
                                        >
                                            {this.props.intl.formatMessage({ id: "do_not_approve" })}
                                        </Button>
                                    </div>
                                </div>
                            )) : ''} 
                        </div>
                    </div>

                    <div className="title subTitle">{this.props.intl.formatMessage({ id: "ce_request_subTitle" })}</div>
                    <div className="requestListTable">
                        <div className="header">
                            <div className="header-label">
                                <span>{this.props.intl.formatMessage({ id: "sender" })}</span>
                            </div>
                            <div className="header-label">
                                <span>{this.props.intl.formatMessage({ id: "ce_request_header_contents" })}</span>
                            </div>
                            <div className="header-label">
                                <span>{this.props.intl.formatMessage({id: "processed_result"})}</span>
                            </div>
                            <div className="header-label">
                                <span>{this.props.intl.formatMessage({id: "processed_date"})}</span>
                            </div>               
                        </div>
                        <div className="historyData" key={ this.state.requestHistory }>
                            { this.state.requestHistory !== undefined ? this.state.requestHistory.map(request => (
                                <div className="data">
                                    <div className="data-value">
                                        <input 
                                            type="email" 
                                            name="email" 
                                            value={request.ceId} 
                                            disabled 
                                        />
                                    </div>
                                    <div className="data-value">
                                        <input 
                                            type="text" 
                                            name="contents" 
                                            value={request.contents} 
                                            disabled
                                        />
                                    </div>
                                    <div className="data-value">
                                        <input 
                                            type="text" 
                                            name="contents" 
                                            value={request.isApproved ? this.props.intl.formatMessage({ id: "approved" }) : this.props.intl.formatMessage({ id: "do_not_approved" })} 
                                            disabled
                                        />
                                    </div>
                                    <div className="data-value">
                                        <input 
                                            type="text" 
                                            name="contents" 
                                            value={request.processedDate} 
                                            disabled
                                        />
                                    </div>
                                </div>
                            )) : ''} 
                        </div>
                    </div>  
                    <Button 
                        fullWidth
                        className="button goBackButton goBackButton-position" 
                        onClick={() => this.goBack()}
                    >
                        {this.props.intl.formatMessage({ id: "header_cancel" })}
                    </Button> 
                    <CompletionDialog 
                        show={this.state.isCompleteDialog}
                        handleClose={this.handleClose}
                        intl={this.props.intl}
                        message={this.state.tipMessage}
                    />  
                </div>
                
            </div>
        )
    }

}


function getRequestContents(requestList) {
    let dataList = [];
    let processedDate;
    requestList.forEach(requestData => {
        if (!!requestData.processedDate) {
            processedDate = moment.utc(requestData.processedDate).local().format(DATETIME_FORMAT);
        } else {
            processedDate = '';
        }
        let data = {
            ceId : requestData.ceId,
            type : requestData.type,
            userId : requestData.userId,
            contents : "",
            isApproved: requestData.isApproved,
            processedDate: processedDate,
            createdAt : moment.utc(requestData.createdAt).local().format(DATETIME_FORMAT)
        };
        if (requestData.type === "ce") {
            data.contents = "Creating dealer account";
        } else if (requestData.type === "user") {
            data.contents = "Add user : " + data.userId;
        }
    
        dataList.push(data);
    });
    return dataList;
}

export default withSnackbar(withRouter(injectIntl(requests)), SNACKBAR_OPTIONS);